// extracted by mini-css-extract-plugin
export default {"outletContainer":"Layout_outletContainer__j6I2z","outletContainerFixed":"Layout_outletContainerFixed__jgFB9"};